import { render, staticRenderFns } from "./sAddModel.vue?vue&type=template&id=25ec814d&scoped=true&"
import script from "./sAddModel.vue?vue&type=script&lang=js&"
export * from "./sAddModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec814d",
  null
  
)

export default component.exports